import React, { FC } from 'react'
import { VerifiedTrustSealRecordEntity } from '../../interface/trust-seal.interface'
import { TRUST_SEAL_IMAGE_BASE } from '../../utils/constant'

interface InvalidatedRecordPropEntity {
    data: VerifiedTrustSealRecordEntity
}

const InvalidatedRecord: FC<InvalidatedRecordPropEntity> = ({ data }) => {
    return (
        <section id="quotation" style={{ paddingBottom: '50px' }}>
            <div className="container">
                <div className="row mx-0">
                    <div className="col-md-3" />
                    <div className="col-md-6 text-center">
                        <div className="p-t-b-30">
                            <div className="p-b-30">
                                <img src={`${TRUST_SEAL_IMAGE_BASE}/invalid.png`} alt="Valid" width="80" />
                            </div>
                            <h6 className="head6">Your Quotation is Invalid</h6>
                            <table className="tbl-bx">
                                <tbody>
                                    <tr className="trows">
                                        <td>Order Number</td>
                                        <td>:</td>
                                        <td>{data.orderNumber}</td>
                                    </tr>
                                    <tr className="trows">
                                        <td>Version Number</td>
                                        <td>:</td>
                                        <td style={{ color: "red" }}>{data.versionNumber}</td>
                                    </tr>
                                    <tr className="trows">
                                        <td>Date generated</td>
                                        <td>:</td>
                                        <td>{data.dateGenerated}</td>
                                    </tr>
                                    <tr className="trows">
                                        <td>Sales Representative</td>
                                        <td>:</td>
                                        <td>{data.salesRepresentative}</td>
                                    </tr>
                                    <tr className="trows">
                                        <td>Distributor Name</td>
                                        <td>:</td>
                                        <td>{data.distributorName}</td>
                                    </tr>
                                    <tr className="no-space order">
                                        <td>Project JURISDICTION</td>
                                        <td>:</td>
                                        <td>{data.cityName}, {data.stateName}</td>
                                    </tr>
                                    <tr className="no-space trows">
                                        <td />
                                        <td />
                                        <td style={{ textTransform: 'none', paddingBottom: '10px' }}>
                                            (This Estimate, material, installation and after-sales service is for project in {data.cityName} jurisdiction only)
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className="row mx-0">
                    <div className="col-md-3"></div>
                    <div className="col-md-6 text-center">
                        <div className="p-t-b-30">
                            <h6 className="head6" style={{ marginBottom: "20px" }}>Recommended Action</h6>
                            <p className="para">THE QUOTATION VERSION IS NO LONGER ACTIVE WITHIN THE WALTZ VERIFICATION SYSTEM. PLEASE CONTACT YOUR WALTZ REPRESENTATIVE TO ACCESS THE LATEST APPROVED VERSION.</p>

                        </div>
                        <div style={{ marginTop: "20px" }}>
                            <button
                                type="button"
                                className="btn-brdr"
                                aria-label="Call Ankit"
                                onClick={() => {
                                    if (typeof window !== 'undefined') {
                                        window.location.href = `tel:${data.salesPersonNumber}`
                                    }
                                }}
                            >
                                <img src={`${TRUST_SEAL_IMAGE_BASE}/phone.png`} style={{ width: "20px", marginRight: "5px" }} alt="phone" /> Call {data.salesRepresentative}
                            </button>
                        </div>

                    </div>
                    <div className="col-md-3"></div>
                </div>
            </div>
        </section >
    )
}

export default InvalidatedRecord